import { useMutation } from '@apollo/client';

import { DELETE_CREW_MEMBER_ABSENCE } from 'common/gql/deleteAbsence';
import { standardDeletedSuccess, standardError } from 'global/commonMessages';
import { notificationStore } from 'global/NotificationStore';
import { FETCH_UNAVAILABITY_DAYS } from 'pages/CrewMemberDetails/components/Unavailability/unavailalbityQuery.gql';

export const useModalDeleteAbsence = ({ initialData, onActionSuccess, onClose }) => {
	const [deleteAbsence, { loading }] = useMutation(DELETE_CREW_MEMBER_ABSENCE, {
		fetchPolicy: 'no-cache',
		refetchQueries: [FETCH_UNAVAILABITY_DAYS],
		onCompleted: async (data) => {
			const response = data?.deleteCrewMemberAbsence;

			if (response?.__typename === 'CrewMemberAbsenceErrorResponse') {
				notificationStore.setNotification({
					header: 'Error!',
					label: "This absence can't be deleted as it has already been processed for payment",
					appearance: 'danger',
				});
				onClose();
				return;
			}

			if (response?.__typename === 'CrewMemberAbsenceConflictingWorkAssignmentsResponse') {
				notificationStore.setNotification(standardError);
				onClose();
				return;
			}

			notificationStore.setNotification(standardDeletedSuccess);
			await Promise.resolve(onActionSuccess(initialData?.fromTimestamp));
			onClose();
		},
		onError: () => {
			notificationStore.setNotification(standardError);
			onClose();
		},
	});

	const confirm = () => {
		if (!initialData?.id) {
			notificationStore.setNotification(standardError);
			return;
		}

		deleteAbsence({ variables: { id: initialData.id } });
	};

	return { loading, confirm };
};
